import { getWGfitApply } from "@src/api/recommend/recommend";
import { useState, useEffect } from "react";
import useUrlQueryString from "../../../utils/hooks/useUrlQueryString";
import PageTitle from "@src/components/common/pageTitle/PageTitle";
import DataSection from "@src/components/form/dataSection/DataSection";
import { FormBlock, FormWrap } from "@src/components/form/formBlock/FormBlock";

interface IUserData {
  name: string;
  tel: string;
  wantPrice: string;
  times: string;
  regTsp: string;
  selectImgs: string[];
  attachImgs: string[];
}

const UserData = () => {
  const query = useUrlQueryString();
  const uuid = query.get("uuid");
  const [userData, setUserData] = useState<IUserData | null>(null);
  useEffect(() => {
    if (!uuid) return;
    (async () => {
      const { data } = await getWGfitApply(uuid);
      setUserData(data.data);
    })();
  }, [uuid]);

  if (!uuid) return null;
  return (
    <div className="page page-wgift-userdata">
      {userData && (
        <div style={{ maxWidth: 640, margin: "0 auto" }}>
          <div style={{ margin: "20px 0" }}>
            <PageTitle
              title={`${userData.name}님이
					${userData.regTsp.substr(0, 10)}일에 신청하신
					예물 AI 추천 내역입니다.`}
            />
          </div>
          <DataSection>
            <FormWrap>
              <FormBlock
                title="이름"
                typeStr=""
                content={
                  <input
                    type="text"
                    className="input-text input-has-line input-full"
                    placeholder="이름"
                    value={userData.name}
                    readOnly={true}
                  />
                }
              />
              <FormBlock
                title="연락처"
                typeStr=""
                content={
                  <input
                    type="tel"
                    className="input-text input-has-line input-full"
                    placeholder="010-0000-0000"
                    value={userData.tel}
                    readOnly={true}
                  />
                }
              />
              <FormBlock
                title="예산대"
                typeStr=""
                content={
                  <input
                    type="tel"
                    className="input-text input-has-line input-full"
                    value={userData.wantPrice}
                    readOnly={true}
                  />
                }
              />
              <FormBlock
                title="연락 가능 시간대"
                typeStr=""
                content={
                  <input
                    type="tel"
                    className="input-text input-has-line input-full"
                    value={userData.times}
                    readOnly={true}
                  />
                }
              />
              <FormBlock
                title="고객님이 선택한 이미지"
                typeStr=""
                content={
                  <div className="image-upload-wrap">
                    <ul>
                      {userData.selectImgs.map((img) => (
                        <li
                          onClick={() => window.open(img)}
                          style={{ backgroundImage: `url(${img})` }}
                        ></li>
                      ))}
                    </ul>
                  </div>
                }
              />
              <FormBlock
                title="고객님이 첨부한 이미지"
                typeStr=""
                content={
                  <div className="image-upload-wrap">
                    <ul>
                      {userData.attachImgs.map((img) => (
                        <li
                          onClick={() => window.open(img)}
                          style={{ backgroundImage: `url(${img})` }}
                        ></li>
                      ))}
                    </ul>
                  </div>
                }
              />
            </FormWrap>
          </DataSection>
        </div>
      )}
    </div>
  );
};

export default UserData;
